import { render, staticRenderFns } from "./OfficesManage.vue?vue&type=template&id=4e05046e&scoped=true&"
import script from "./OfficesManage.vue?vue&type=script&lang=js&"
export * from "./OfficesManage.vue?vue&type=script&lang=js&"
import style0 from "./OfficesManage.vue?vue&type=style&index=0&id=4e05046e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e05046e",
  null
  
)

export default component.exports